import React from 'react'

export default function IconsPersonOutline({ color = '', style = {} }) {
    let fillColor = '#7246B1'
    if (color) fillColor = color
    let className = 'icons-icon'

    return (
        <svg
            className={className}
            style={style}
            width='20'
            height='20'
            viewBox='0 0 20 20'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M10.0002 10.8333C12.3013 10.8333 14.1668 8.96785 14.1668 6.66667C14.1668 4.36548 12.3013 2.5 10.0002 2.5C7.69898 2.5 5.8335 4.36548 5.8335 6.66667C5.8335 8.96785 7.69898 10.8333 10.0002 10.8333Z'
                stroke={fillColor}
                strokeWidth='1.5'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M16.6668 17.4999C16.6668 15.7318 15.9645 14.0361 14.7142 12.7859C13.464 11.5356 11.7683 10.8333 10.0002 10.8333C8.23205 10.8333 6.53636 11.5356 5.28612 12.7859C4.03588 14.0361 3.3335 15.7318 3.3335 17.4999'
                stroke={fillColor}
                strokeWidth='1.5'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
        </svg>
    )
}
